import { useContext } from 'react';
import { UserProfileContext } from 'src/contexts/UserProfileContext';

const useUserProfile = () => useContext(UserProfileContext)

export default useUserProfile